// ============================================================
// Sur-mesure Coat Form — JS
// ============================================================

// Collect checked checkbox values into a hidden field
function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll(
    '[hidden-data="' + hiddenname + '"]'
  );
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = "";
  for (var i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value === "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}

// ============================================================
// Price Calculator (model-keyed, not size-keyed)
// ============================================================
class CoatPriceCalculator {
  constructor(pricingUrl) {
    this.pricingUrl = pricingUrl;
    this.pricing = null;
    this.modelRadios = [];
    this.optionCheckboxes = [];
    this.bourreCheckbox = null;
    this.priceDisplay = null;
    this.priceContainer = null;
    this.init();
  }

  init() {
    fetch(this.pricingUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        this.pricing = data;
        this.setup();
      }.bind(this))
      .catch(function () {
        this.setup();
      }.bind(this));
  }

  setup() {
    var self = this;

    this.modelRadios = document.querySelectorAll('.model-radio');
    this.optionCheckboxes = document.querySelectorAll('.option-checkbox');
    this.bourreCheckbox = document.getElementById('coat-bourre-laine');
    this.customStitchingSelect = document.getElementById('coat-custom-stitching');
    this.customStitchingSection = document.getElementById('custom-stitching-section');
    this.piqureRadios = document.querySelectorAll('.piqure-radio');
    this.priceDisplay = document.getElementById('price-amount');
    this.priceContainer = document.getElementById('price-calculator');

    // Store original dropdown option labels (without prices)
    this.stitchingBaseLabels = [];
    if (this.customStitchingSelect) {
      var opts = this.customStitchingSelect.options;
      for (var i = 0; i < opts.length; i++) {
        this.stitchingBaseLabels.push(opts[i].textContent);
      }
    }

    this.modelRadios.forEach(function (radio) {
      radio.addEventListener('change', function () { self.updatePrice(); });
    });

    this.optionCheckboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () { self.updatePrice(); });
    });

    if (this.bourreCheckbox) {
      this.bourreCheckbox.addEventListener('change', function () { self.updatePrice(); });
    }

    if (this.customStitchingSelect) {
      this.customStitchingSelect.addEventListener('change', function () { self.updatePrice(); });
    }

    // Toggle custom stitching dropdown based on piqûre tile
    this.piqureRadios.forEach(function (radio) {
      radio.addEventListener('change', function () { self.handlePiqureChange(); });
    });
  }

  handlePiqureChange() {
    var checked = document.querySelector('.piqure-radio:checked');
    var isCustom = checked && checked.getAttribute('data-custom') === 'true';
    if (this.customStitchingSection) {
      this.customStitchingSection.style.display = isCustom ? '' : 'none';
    }
    // Reset dropdown when switching away from custom
    if (!isCustom && this.customStitchingSelect) {
      this.customStitchingSelect.selectedIndex = 0;
    }
    this.updatePrice();
  }

  getSelectedModel() {
    var checked = document.querySelector('.model-radio:checked');
    return checked ? checked.value.toLowerCase() : null;
  }

  updateOptionLabels(modelId) {
    var self = this;
    this.optionCheckboxes.forEach(function (checkbox) {
      var label = checkbox.closest('label');
      if (!label) return;
      var priceSpan = label.querySelector('.option-price');
      if (!priceSpan) return;
      if (!modelId || !self.pricing) { priceSpan.textContent = ''; return; }
      var key = checkbox.getAttribute('data-option-key');
      if (!key || !self.pricing.options[key]) { priceSpan.textContent = ''; return; }
      var opt = self.pricing.options[key];
      var price = opt.flat !== undefined
        ? opt.flat
        : (opt.prices && opt.prices[modelId] !== undefined ? opt.prices[modelId] : null);
      priceSpan.textContent = price !== null ? ' (+' + price + '$)' : '';
    });

    // Update custom stitching dropdown labels with prices
    if (this.customStitchingSelect && this.pricing) {
      var opts = this.customStitchingSelect.options;
      for (var i = 0; i < opts.length; i++) {
        var key = opts[i].getAttribute('data-option-key');
        var baseLabel = this.stitchingBaseLabels[i] || opts[i].textContent;
        if (!key || !modelId) { opts[i].textContent = baseLabel; continue; }
        var optData = this.pricing.options[key];
        if (optData) {
          var price = optData.flat !== undefined
            ? optData.flat
            : (optData.prices && optData.prices[modelId] !== undefined ? optData.prices[modelId] : null);
          opts[i].textContent = price !== null ? baseLabel + ' (+' + price + '$)' : baseLabel;
        } else {
          opts[i].textContent = baseLabel;
        }
      }
    }

    // Update bourre label
    if (this.bourreCheckbox && this.pricing) {
      var bourreLabel = this.bourreCheckbox.closest('label') || this.bourreCheckbox.parentElement;
      if (bourreLabel) {
        var bourreSpan = bourreLabel.querySelector('.option-price');
        if (bourreSpan) {
          var opt = this.pricing.options.bourre_laine;
          if (opt && opt.prices && modelId && opt.prices[modelId] !== undefined) {
            bourreSpan.textContent = ' (+' + opt.prices[modelId] + '$)';
          } else {
            bourreSpan.textContent = '';
          }
        }
      }
    }
  }

  updatePrice() {
    var modelId = this.getSelectedModel();

    if (!modelId) {
      if (this.priceContainer) this.priceContainer.style.display = 'none';
      this.updateOptionLabels(null);
      return;
    }

    this.updateOptionLabels(modelId);

    var total = 0;
    var exact = true;

    if (this.pricing && this.pricing.base[modelId] !== undefined) {
      total += this.pricing.base[modelId];
    } else {
      exact = false;
    }

    // Bourre de laine
    if (this.bourreCheckbox && this.bourreCheckbox.checked && this.pricing) {
      var bourre = this.pricing.options.bourre_laine;
      if (bourre && bourre.prices && bourre.prices[modelId] !== undefined) {
        total += bourre.prices[modelId];
      } else {
        exact = false;
      }
    }

    // Option checkboxes
    var self = this;
    this.optionCheckboxes.forEach(function (checkbox) {
      if (!checkbox.checked) return;
      var key = checkbox.getAttribute('data-option-key');
      if (!key || !self.pricing || !self.pricing.options[key]) {
        exact = false;
        return;
      }
      var opt = self.pricing.options[key];
      if (opt.flat !== undefined) {
        total += opt.flat;
      } else if (opt.prices && modelId && opt.prices[modelId] !== undefined) {
        total += opt.prices[modelId];
      } else {
        exact = false;
      }
    });

    // Custom stitching dropdown
    if (this.customStitchingSelect && this.customStitchingSelect.value && this.pricing) {
      var selOpt = this.customStitchingSelect.options[this.customStitchingSelect.selectedIndex];
      var key = selOpt.getAttribute('data-option-key');
      if (key && this.pricing.options[key]) {
        var opt = this.pricing.options[key];
        if (opt.flat !== undefined) {
          total += opt.flat;
        } else if (opt.prices && opt.prices[modelId] !== undefined) {
          total += opt.prices[modelId];
        } else {
          exact = false;
        }
      }
    }

    if (this.priceContainer) this.priceContainer.style.display = 'block';
    if (this.priceDisplay) {
      this.priceDisplay.textContent = (exact ? '' : '~') + total + '$';
    }
  }
}

// ============================================================
// Model Toggle — sizes, sizing chart, big image
// ============================================================
class CoatModelToggle {
  constructor() {
    this.marilyn = ['stanbridge', 'windsor'];
    this.odeyalo = ['noren', 'santos'];
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.setup.bind(this));
    } else {
      this.setup();
    }
  }

  setup() {
    var self = this;
    this.sizeSelectMarilyn = document.getElementById('coat-size-marilyn');
    this.sizeSelectOdeyalo = document.getElementById('coat-size-odeyalo');
    this.chartMarilyn = document.getElementById('sizing-chart-marilyn');
    this.chartOdeyalo = document.getElementById('sizing-chart-odeyalo');
    this.optionsSection = document.getElementById('coat-options-section');
    this.bigImage = document.querySelector('.svg-preview img');
    this.modelRadios = document.querySelectorAll('.model-radio');

    this.modelRadios.forEach(function (radio) {
      radio.addEventListener('change', function (e) { self.handleModelChange(e.target); });
    });

    // Set initial state
    var checked = document.querySelector('.model-radio:checked');
    if (checked) {
      this.handleModelChange(checked);
    }
  }

  handleModelChange(radio) {
    var model = radio.value.toLowerCase();
    var isMarilyn = this.marilyn.indexOf(model) !== -1;

    // Toggle size dropdowns 
    if (this.sizeSelectMarilyn && this.sizeSelectOdeyalo) {
      if (isMarilyn) {
        this.sizeSelectMarilyn.style.display = '';
        this.sizeSelectMarilyn.disabled = false;
        this.sizeSelectMarilyn.name = this.sizeSelectMarilyn.getAttribute('data-name');
        this.sizeSelectOdeyalo.style.display = 'none';
        this.sizeSelectOdeyalo.disabled = true;
        this.sizeSelectOdeyalo.name = '';
      } else {
        this.sizeSelectOdeyalo.style.display = '';
        this.sizeSelectOdeyalo.disabled = false;
        this.sizeSelectOdeyalo.name = this.sizeSelectOdeyalo.getAttribute('data-name');
        this.sizeSelectMarilyn.style.display = 'none';
        this.sizeSelectMarilyn.disabled = true;
        this.sizeSelectMarilyn.name = '';
      }
    }

    // Toggle sizing charts
    if (this.chartMarilyn) {
      this.chartMarilyn.style.display = isMarilyn ? '' : 'none';
    }
    if (this.chartOdeyalo) {
      this.chartOdeyalo.style.display = isMarilyn ? 'none' : '';
    }

    // Toggle options section (only for Odeyalo coats)
    if (this.optionsSection) {
      this.optionsSection.style.display = isMarilyn ? 'none' : '';
      // Uncheck the option when hiding so it doesn't submit stale data
      if (isMarilyn) {
        var cb = this.optionsSection.querySelector('.option-checkbox');
        if (cb && cb.checked) { cb.checked = false; fillHidden('Options'); }
      }
    }

    // Swap big image
    if (this.bigImage) {
      var imgUrl = radio.getAttribute('data-big-img');
      if (imgUrl) {
        this.bigImage.src = imgUrl;
        this.bigImage.alt = radio.value;
      }
    }
  }
}

// ============================================================
// Visualization Link Builder — keeps return_to in sync
// ============================================================
class CoatVizLinkBuilder {
  constructor() {
    this.init();
  }

  init() {
    var self = this;
    document.querySelectorAll('.model-radio').forEach(function (radio) {
      radio.addEventListener('change', function () { self.update(); });
    });
    document.querySelectorAll('.image[data-color]').forEach(function (cb) {
      cb.addEventListener('change', function () { self.update(); });
    });
  }

  update() {
    var modelRadio = document.querySelector('.model-radio:checked');
    var modelKey   = modelRadio ? modelRadio.getAttribute('data-model') : '';
    var colorHexes = Array.from(document.querySelectorAll('.image[data-color]:checked'))
      .map(function (cb) { return cb.getAttribute('data-color').replace('#', ''); })
      .filter(Boolean);

    var params = new URLSearchParams();
    if (modelKey)           params.set('model',  modelKey);
    if (colorHexes.length)  params.set('colors', colorHexes.join(','));

    var returnTo = document.getElementById('ReturnTo');
    if (returnTo) {
      returnTo.value = '/pages/sur-mesure-confirmation' + (params.toString() ? '?' + params.toString() : '');
    }
  }
}

// ============================================================
// Initialize
// ============================================================
document.addEventListener('DOMContentLoaded', function () {
  if (window.PRICING_URL) {
    new CoatPriceCalculator(window.PRICING_URL);
  }
  new CoatModelToggle();
  new CoatVizLinkBuilder();
});
